import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TextKey } from '@mews/text-keys';

export const useIsTextKey = () => {
    const intl = useIntl();

    return useCallback(
        (textKey: unknown): textKey is TextKey => {
            return (textKey as PropertyKey) in intl.messages;
        },
        [intl]
    );
};
